/* Flowfull - "Kunden kauften auch":
   1) Pfeile verdrahten (scrollt exakt 1 Kachel)
   2) Produkt-Titel sauber auf 2 Zeilen klammern (per JS, weil die App via Inline-Styles
      display:flow-root + min-height:3em erzwingt und damit CSS-line-clamp aushebelt)

   Einbau:
   1) Theme-Editor -> Code bearbeiten -> Assets -> "Eine neue Datei hinzufügen" -> cbb-nav.js -> diesen Inhalt einfügen
   2) In layout/theme.liquid kurz vor </body> einfügen:
      <script src="{{ 'cbb-nav.js' | asset_url }}" defer></script>
   (Externe Datei nötig, weil der Store Inline-Scripts per CSP blockt.) */

(function () {
  // 2-Zeilen-Titel: feste Höhe (2 x line-height), Rest ausgeblendet, endet am Wort
  function clampNames(root) {
    (root || document).querySelectorAll('.cbb-also-bought-product-name').forEach(function (n) {
      // Guard statt Flag: nur setzen, wenn noch nicht korrekt (verhindert Loop, erlaubt aber Re-Apply,
      // falls die App den Titel nachträglich umstylt - z.B. auf Mobile).
      if (n.style.getPropertyValue('height') === '32px' && n.style.getPropertyValue('line-height') === '16px') return;
      var st = n.style;
      st.setProperty('display', 'block', 'important');
      st.setProperty('font-size', '12.5px', 'important');
      st.setProperty('font-weight', '600', 'important');
      st.setProperty('line-height', '16px', 'important');
      st.setProperty('height', '32px', 'important');
      st.setProperty('min-height', '0', 'important');
      st.setProperty('max-height', '32px', 'important');
      st.setProperty('overflow', 'hidden', 'important');
      st.setProperty('margin', '8px 0 6px', 'important');
      var a = n.querySelector('a');
      if (a) {
        a.style.setProperty('font-size', '12.5px', 'important');
        a.style.setProperty('line-height', '16px', 'important');
        a.style.setProperty('color', '#1a1a1a', 'important');
      }
    });
  }

  // Pfeile: scrollt exakt eine Kachel
  function wireArrows(root) {
    (root || document).querySelectorAll('.cbb-also-bought-slider-container').forEach(function (cont) {
      var slider = cont.querySelector('.cbb-also-bought-slider');
      if (!slider || slider.__ffWired) return;
      slider.__ffWired = true;
      function step() {
        var p = cont.querySelectorAll('.cbb-also-bought-product');
        if (p.length >= 2) {
          var d = Math.round(p[1].getBoundingClientRect().left - p[0].getBoundingClientRect().left);
          if (d > 40) return d;
        }
        return p[0] ? Math.round(p[0].getBoundingClientRect().width) + 10 : 180;
      }
      function go(dir) { slider.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
      cont.querySelectorAll('.cbb-also-bought-next').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
      });
      cont.querySelectorAll('.cbb-also-bought-prev').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      });
    });
  }

  function run() { clampNames(); wireArrows(); }

  function start() {
    run();
    // App rendert/aktualisiert die Box teils verzögert -> beobachten und nachziehen.
    // (Beobachtet nur childList; unsere Style-Änderungen lösen das nicht aus -> keine Endlosschleife.)
    var obs = new MutationObserver(function () { run(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // Sicherheits-Nachläufe für sehr späte Renders (auch Mobile)
    [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(run, t); });
    // Re-Apply bei Resize/Orientierungswechsel (Mobile)
    window.addEventListener('resize', function () { setTimeout(run, 100); });
    window.addEventListener('orientationchange', function () { setTimeout(run, 200); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();